import { cva } from "class-variance-authority";

const dotVariants = cva("h-2.5 w-2.5 rounded-full", {
  variants: {
    status: {
      connected: "bg-chart-6",
      disconnected: "bg-destructive",
      finalized: "bg-muted-foreground",
    },
  },
});

export type ConnectionStatusType = "connected" | "disconnected" | "finalized";

interface ConnectionStatusProps {
  status: ConnectionStatusType;
  showLabel?: boolean;
}

const labels: Record<ConnectionStatusType, string> = {
  connected: "Live",
  disconnected: "Disconnected",
  finalized: "Finalized",
};

export function ConnectionStatus({
  status,
  showLabel = true,
}: ConnectionStatusProps) {
  return (
    <div className="flex items-center gap-2 text-sm text-muted-foreground">
      <span className="relative flex h-2.5 w-2.5">
        {status === "connected" && (
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-chart-6 opacity-75" />
        )}
        <span className={dotVariants({ status })} />
      </span>
      {showLabel && <span>{labels[status]}</span>}
    </div>
  );
}
